<template>
  <a id="fund-transactions-download-pdf-button" href="#/" class="pdf-ptn" @click="downloadTransaction(params.data.id)">Download PDF</a>
</template>

<script>
export default {
  methods: {
    async downloadTransaction (transactionId) {
      const response = await window.axios.get(`/payments/transactions/${transactionId}/download`, {
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'receipt.pdf')
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style scoped>
  .pdf-btn {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.107143px;
    color: #0092d7;
  }
</style>
